(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aupres-pdp-reviews"] && !Shopify.designMode) return;
  try {
    

(function () {
  const main = document.getElementById('MainContent');
  if (!main || main.dataset.aupresReviewScroll) return;
  main.dataset.aupresReviewScroll = 'true';
  let cancelScroll = null;
  main.addEventListener('click', function (event) {
    const link = event.target.closest('a.apg__rating, a.apd-hd__rate');
    if (!link || link.getAttribute('href') !== '#avis-clients' || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById('avis-clients');
    if (!target) return;
    event.preventDefault();
    if (cancelScroll) cancelScroll();
    const start = window.scrollY;
    const offset = parseFloat(getComputedStyle(target).scrollMarginTop) || 100;
    const destination = Math.max(0, Math.min(start + target.getBoundingClientRect().top - offset, document.documentElement.scrollHeight - window.innerHeight));
    const finish = function () {
      target.focus({preventScroll: true});
      history.replaceState(history.state, '', '#avis-clients');
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.scrollTo({top: destination, behavior: 'instant'});
      finish();
      return;
    }
    let frame;
    let started;
    const duration = 950;
    const cleanup = function () {
      cancelAnimationFrame(frame);
      window.removeEventListener('wheel', cleanup);
      window.removeEventListener('touchstart', cleanup);
      window.removeEventListener('keydown', onKey);
      cancelScroll = null;
    };
    const onKey = function (event) {
      if (['ArrowUp','ArrowDown','PageUp','PageDown','Home','End',' ','Escape'].includes(event.key)) cleanup();
    };
    cancelScroll = cleanup;
    window.addEventListener('wheel', cleanup, {passive: true});
    window.addEventListener('touchstart', cleanup, {passive: true});
    window.addEventListener('keydown', onKey);
    const step = function (now) {
      if (started === undefined) started = now;
      const progress = Math.min((now - started) / duration, 1);
      const eased = progress < 0.5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2;
      window.scrollTo({top: start + (destination - start) * eased, behavior: 'instant'});
      if (progress < 1) frame = requestAnimationFrame(step);
      else { cleanup(); finish(); }
    };
    frame = requestAnimationFrame(step);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aupres-studio-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aupres-studio-video')) {
  customElements.define('aupres-studio-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.canvas = this.querySelector('canvas');
      this.context = this.canvas.getContext('2d', { alpha: false });
      this.drawSides = (source = this.video) => {
        const width = source.videoWidth || source.naturalWidth;
        const height = source.videoHeight || source.naturalHeight;
        if (!width || !height || !this.context) return;
        this.context.drawImage(source, 0, 0, 1, height, 0, 0, 2, 1080);
        this.context.drawImage(source, width - 1, 0, 1, height, 2, 0, 2, 1080);
        this.setAttribute('data-sides-ready', '');
      };
      this.updateSides = () => {
        this.drawSides();
        if (!this.video.paused && this.isConnected) {
          this.sideFrame = this.video.requestVideoFrameCallback ? this.video.requestVideoFrameCallback(this.updateSides) : requestAnimationFrame(this.updateSides);
        }
      };
      this.stopSides = () => {
        if (this.sideFrame === undefined) return;
        if (this.video.cancelVideoFrameCallback) this.video.cancelVideoFrameCallback(this.sideFrame);
        else cancelAnimationFrame(this.sideFrame);
        this.sideFrame = undefined;
      };
      this.onVideoFrame = () => this.drawSides();
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.hero = document.querySelector('.aph--d');
      this.matchHeroHeight = () => {
        if (!this.desktop.matches || !this.hero) return;
        const height = this.hero.getBoundingClientRect().height;
        if (height > 0) this.style.setProperty('--aupres-video-height', height + 'px');
      };
      this.heroObserver = new ResizeObserver(this.matchHeroHeight);
      if (this.hero) this.heroObserver.observe(this.hero);
      this.matchHeroHeight();
      this.visible = false;
      this.userPaused = false;
      this.onViewport = () => { this.matchHeroHeight(); this.sync(); };
      this.onVisibility = () => this.sync();
      this.onMotion = () => { this.manualPlay = false; this.sync(); };
      this.onPlayback = () => {
        this.stopSides();
        this.updateSides();
        this.toggleAttribute('data-playing', !this.video.paused);
        this.button.setAttribute('aria-label', this.video.paused ? this.button.dataset.play : this.button.dataset.pause);
      };
      this.onToggle = () => {
        if (this.video.paused) {
          this.userPaused = false;
          this.manualPlay = true;
          this.sync();
        } else {
          this.userPaused = true;
          this.video.pause();
        }
      };
      this.desktop.addEventListener('change', this.onViewport);
      this.reduced.addEventListener('change', this.onMotion);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.video.addEventListener('loadeddata', this.onVideoFrame);
      this.video.addEventListener('seeked', this.onVideoFrame);
      this.video.addEventListener('play', this.onPlayback);
      this.video.addEventListener('pause', this.onPlayback);
      this.button.addEventListener('click', this.onToggle);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.15;
        this.sync();
      }, { threshold: [0, 0.15] });
      this.observer.observe(this);
      this.sync();
    }
    sync() {
      if (!this.desktop.matches) {
        this.video.pause();
        if (this.video.hasAttribute('src')) {
          this.video.removeAttribute('src');
          this.video.removeAttribute('poster');
          this.video.load();
        }
        return;
      }
      if (this.dataset.poster && !this.video.hasAttribute('poster')) {
        this.video.poster = this.dataset.poster;
        this.posterImage = new Image();
        this.posterImage.onload = () => {
          if (this.video.readyState < 2 && this.isConnected) this.drawSides(this.posterImage);
        };
        this.posterImage.src = this.dataset.poster;
      }
      if (!this.visible || document.hidden || this.userPaused || (this.reduced.matches && !this.manualPlay)) {
        this.video.pause();
        return;
      }
      if (!this.video.hasAttribute('src')) this.video.src = this.video.dataset.src;
      this.video.muted = true;
      this.video.play().catch(() => this.onPlayback());
    }
    disconnectedCallback() {
      this.observer.disconnect();
      this.heroObserver.disconnect();
      this.video.pause();
      this.desktop.removeEventListener('change', this.onViewport);
      this.reduced.removeEventListener('change', this.onMotion);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.stopSides();
      if (this.posterImage) this.posterImage.onload = null;
      this.video.removeEventListener('loadeddata', this.onVideoFrame);
      this.video.removeEventListener('seeked', this.onVideoFrame);
      this.video.removeEventListener('play', this.onPlayback);
      this.video.removeEventListener('pause', this.onPlayback);
      this.button.removeEventListener('click', this.onToggle);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-sauv-20261023"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-sauv-20261027b"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
